module.exports = __webpack_public_path__ + "img/hyundai_sonata_new.eddbe528.png";